import React from 'react';
import './AchievementSection.css';

const AchievementSection = ({ config }) => {
  return (
    <div className="achievement-section">
      <div className="achievement-content">
        <div className="achievement-background-text">
          {config.backgroundText === "Description of previous projects" ? (
            <>
              Description of<br />
              previous projects
            </>
          ) : (
            config.backgroundText
          )}
        </div>
        
        <div className="achievement-main">
          <h2 className="achievement-title">
            {config.title === "Description of previous projects" ? (
              <>
                Description of<br />
                previous projects
              </>
            ) : (
              config.title
            )}
          </h2>
          
          <div className="achievement-content-wrapper">
            <div className="achievement-text">
              <div className="achievement-subsection">
                <h3 className="subsection-title">{config.engineeringLeadership.title}</h3>
                <p className="subsection-text">{config.engineeringLeadership.text}</p>
              </div>
              
              <div className="achievement-subsection">
                <h3 className="subsection-title">{config.constructionPartners.title}</h3>
                <p className="subsection-text">{config.constructionPartners.text}</p>
                <ul className="achievement-list">
                  {config.constructionPartners.achievements.map((achievement, index) => (
                    <li key={index} className="achievement-item">
                      {achievement}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            
            <div className="achievement-images">
              <div className="top-right-image">
                <img 
                  src={config.images.topRight} 
                  alt="Engineering work"
                  className="achievement-img"
                />
              </div>
              <div className="bottom-right-image">
                <img 
                  src={config.images.bottomRight} 
                  alt="Modern skyscrapers"
                  className="achievement-img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AchievementSection;
